import { useCallback } from "react";
import { Icon, Link } from "@zapier/design-system";
import { Tooltip } from "@zapier/design-system-beta";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

import styles from "./ChatbotLink.module.css";

type Props = { chatbotId: string };

export function ChatbotLink({ chatbotId }: Props) {
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  const onClick = useCallback(() => {
    emitEventOnAssetOpen({
      asset: "Chatbot",
      location: "node",
    });
  }, [emitEventOnAssetOpen]);

  return (
    <Tooltip placement="top" content="Open chatbot">
      <Tooltip.FocusableTrigger>
        <Link
          href={`/app/chatbots/${chatbotId}`}
          className={styles.linkWrapper}
          target="_blank"
          onClick={onClick}
        >
          <Icon name="arrowOffsite" size={20} color="GrayWarm5" />
        </Link>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}
